import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaGatewayLink" */ './lazyIndex'),
    { name: 'OwaGatewayLink' }
);

export const lazyGatewayLink: LazyAction<typeof lazyIndex.gatewayLink, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.gatewayLink);
export const lazyMakeGatewayRequest: LazyAction<
    typeof lazyIndex.makeGatewayRequest,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.makeGatewayRequest);
